import { parseGlobIcon } from '@utils/parse-glob-icon';
import { type FC, memo } from 'react';
import styles from './links.module.scss';
import statsIcon from '@assets/images/parrot/stats.svg';
import apiIcon from '@assets/images/parrot/api.svg';
import aboutIcon from '@assets/images/parrot/about.svg';
import suiBridgeIcon from '@assets/images/parrot/sui-bridge.svg';
import wormholeIcon from '@assets/images/parrot/wormhole.svg';
import { Link } from 'react-router-dom';

const Links: FC = () => {
  return (
    <div className={styles.wrapper}>
      <Link to="/" className={styles.list}>
        <img src={statsIcon} data-coin />
        Stats
      </Link>
      <div className={styles.title}>Bridge</div>
      <ul className={styles.menus}>
        <li>
          <Link to="/">
            <img src={suiBridgeIcon} data-coin />
            Sui Bridge
          </Link>
        </li>
        <li>
          <Link to="/">
            <img src={wormholeIcon} data-coin />
            Wormhole
          </Link>
        </li>
      </ul>
      <Link to="/" className={styles.list}>
        <img src={apiIcon} data-coin />
        API
      </Link>
      <Link to="/" className={styles.list}>
        <img src={aboutIcon} data-coin />
        About
      </Link>
      <div className={styles.links}>
        <a href="" target="_blank" rel="noreferrer">
          <img src={getSocialIcon('twitter')} />
        </a>
        <a href="" target="_blank" rel="noreferrer">
          <img src={getSocialIcon('telegram')} />
        </a>
        {/* <a href="https://medium.com/@turbos" target="_blank" rel="noreferrer">
          <img src={getSocialIcon('medium')} />
        </a> */}
        <a href="" target="_blank" rel="noreferrer">
          <img src={getSocialIcon('github')} />
        </a>
        <a href="" target="_blank" rel="noreferrer">
          <img src={getSocialIcon('gitbook')} />
        </a>
        <a href="" target="_blank" rel="noreferrer">
          <img src={getSocialIcon('discord')} />
        </a>
      </div>
    </div>
  );
};

const getSocialIcon = parseGlobIcon(
  import.meta.glob('../../assets/images/socials/*', {
    eager: true,
    import: 'default',
  }),
);

export default memo(Links);
